import React, { Component } from "react";
import { withAppData } from "../../app/withAppData";
class Social extends Component {
  render() {
    const { social, loading } = this.props.appData;
    const socials = Array.isArray(social?.socials) ? social.socials : [];
    return (
      <div className="ltn__social-media">
        {!loading && social && (
          <ul>
            {socials.map((item, i) => (
              <li key={i}>
                <a
                  href={item.url}
                  title={item.platform}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className={item.icon} />
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}

export default withAppData(Social);
